export default __webpack_public_path__ + "static/media/agregar-dinero-tarjeta.bc1269bd.png";